import React, { ReactNode } from "react";
import Container from "react-bootstrap/Container";
import styles from "./BootstrapWrapper.module.css";

type Props = {
  children: ReactNode;
};

const BootstrapWrapper: React.FC<Props> = ({ children }) => (
  <Container fluid className={styles.wrapper}>
    {children}
  </Container>
);

export default BootstrapWrapper;
